import { Component, OnInit } from '@angular/core';
import { WhatsNew } from '@carm/_core/alerts/models/whatsNew.model';
import { BasePageComponent } from '@carm/_utils/base-page.component';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'carm-whats-new-widget',
  templateUrl: './whats-new.component.html',
})
export class WhatsNewWidgetComponent extends BasePageComponent implements OnInit {

  whatsNew: WhatsNew;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.alertService.getWhatsNew()
    .pipe(takeUntil(this.destroy$))
    .subscribe((response) => {
      this.whatsNew = response;
    }, (err) => {
      this.trySetPageErrorMessages(err);
    });
  }
}
